module.exports = __webpack_public_path__ + "img/h2.f205752e.png";